import { Navigate, Outlet } from 'react-router-dom';
import { BootSplash } from '@/components/layout';
import { useBusiness } from '@/hooks/useBusiness';

/** Everything under /app needs a business profile to exist first. */
export function RequireBusiness() {
  const { isReady, activeBusiness } = useBusiness();

  if (!isReady) return <BootSplash />;
  if (!activeBusiness) return <Navigate to="/" replace />;
  return <Outlet />;
}
